import { Component, OnInit,} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from  '@angular/forms';
import { Router } from  '@angular/router';
import { User } from  '../../../user';
import { AuthenticationService } from  '../../../services/authentication/authentication.service';
import { BoardsService } from 'src/app/services/boardsPage/boards.service';
import { OpportunitiesService } from 'src/app/services/opportunitiesPage/opportunities.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  authForm: UntypedFormGroup;
  //isSubmitted = false
  public errorMsg;
  invalidLogin = false;
  resetPassword = false;
  notMatchedNewPassword = false;

  constructor(private opportunitiesService: OpportunitiesService,private boardsService: BoardsService, private authService: AuthenticationService , private router: Router, private formBuilder: UntypedFormBuilder) { }

  ngOnInit(): void {
    this.authForm  =  this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
  });
  }

  get formControls() { return this.authForm.controls; }

  checkLogin() {
    if(this.authForm.invalid){
      return;
    }

    this.boardsService.resetFilters();
    this.opportunitiesService.resetFilters();

    var  loginBtn = <HTMLSelectElement>document.getElementById('login-submit');
    loginBtn.value = "Log In";


    this.authService.authenticate(this.authForm.value).subscribe(
      data => {
        let response;
        try {
          response = JSON.parse(data);
        } catch (e) {
          console.error(e);
        }

        if(response.status === 'resetPassword') {

          // console.log("resetPassword");
          this.resetPassword = true;

          var newPassword = <HTMLSelectElement>document.getElementById('newPassword');
          var confirmPassword = <HTMLSelectElement>document.getElementById('confirmPassword');
          loginBtn.value = "Reset Password";

          if (newPassword !=null && newPassword.value != confirmPassword.value) {
            this.notMatchedNewPassword = true;
            return;
          } else if(newPassword !=null && newPassword.value === confirmPassword.value){
            this.authForm.value.password = newPassword.value;
            (this.authService.resetPassword(this.authForm.value).subscribe(
              response => {
                // this.resetPassword = false;
                // var password = <HTMLSelectElement>document.getElementById('password');
                // password.value = newPassword.value;
                // loginBtn.value = "Login";
                
                window.location.reload();
              },
              errorResp => {
                this.invalidLogin = true
                // console.log(this.invalidLogin)
                this.errorMsg = errorResp
              }
              ));
            }


        } else {
          this.authService.getPermissions().subscribe(
            roles => {
              if (roles) {
                const firstAvailablePage = this.getFirstAvailablePage(roles);
                if (firstAvailablePage) {
                  this.router.navigate([firstAvailablePage]);
                  this.invalidLogin = false;
                } else {
                  this.handleNoPermissions();
                }
              } else {
                this.handleNoPermissions();
              }
            },
            error => {
              this.handleNoPermissions();
            }
          );
        }
      },
      error => {
        this.invalidLogin = true;
        this.errorMsg = error;
      }
    );
  }


  private getFirstAvailablePage(roles): string | null {
    const { applianceRole, cadenceRole } = roles;

    if (cadenceRole?.cadenceMenu) {
      return '/boards';
    }

    if (applianceRole?.stockManagement) {
      return '/stocks';
    }
    if (applianceRole?.orderManagement) {
      return '/Order';
    }
    if (applianceRole?.inventoryManagement) {
      return '/inventory';
    }
    if (applianceRole?.fileProcessingManagement) {
      return '/file-processing';
    }
    if (applianceRole?.RFPManagement) {
      return '/rfp';
    }
    if (applianceRole?.prospectsManagement) {
      return '/prospects';
    }

    if (cadenceRole?.userManagement) {
      return '/usermgmt';
    }
    if (cadenceRole?.customerManagement) {
      return '/customermgmt';
    }
    if (cadenceRole?.lookupManagement) {
      return '/lookupmgmt';
    }

    return null;
  }

  private handleNoPermissions() {

    this.authService.logOut().subscribe(
      () => {
        this.router.navigate(['/']);
      },
      error => {
        console.error('Logout failed', error);
        this.router.navigate(['/']);
      }
    );
  }

}
